import graphicsUrl from "@/assets/select-your-repository-showcase-graphics.svg";
import { forwardRef } from "react";

export const SelectRepositoryShowcase = forwardRef<HTMLDivElement>(function SelectRepositoryShowcase(_props, ref) {
    return (
        <div ref={ref} className="flex h-full w-full flex-col items-center justify-center px-8">
            <img
                src={graphicsUrl}
                alt="Graphics for increasing autonomy through security"
                className="mb-6 w-full max-w-md select-none object-contain"
            />
            <p className="mb-2 text-center text-2xl font-medium text-black lg:text-3xl dark:text-white">
                Sandboxed Ona environments
            </p>
            <p className="max-w-lg text-center text-base text-content-secondary lg:text-lg">
                Each Ona Agent executes within ephemeral Ona Environments with full OS-level isolation.
            </p>
        </div>
    );
});
